import { StoreSelector } from '@editor/types';

import { TeamsStoreState } from './types';

export const teamsStoreSelector: StoreSelector<TeamsStoreState> = {
  showCreateTeamModal: (state) => state.showCreateTeamModal,
  setShowCreateTeamModal: (state) => state.setShowCreateTeamModal,
  createTeamFlowState: (state) => state.createTeamFlowState,
  setCreateTeamFlowState: (state) => state.setCreateTeamFlowState,
  chooseTeamPlanFlowState: (state) => state.chooseTeamPlanFlowState,
  setChooseTeamPlanFlowState: (state) => state.setChooseTeamPlanFlowState,
};
